import loginedApi, { adminApi } from "../apis";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import Cookies from "universal-cookie";
import axios from "axios";
import { LOGIN_SUCCESS_ACTION, LOG_OUT_ACTION, UPDATE_LOGIN, CLEAR_INTERBRANCH_ADMIN } from "./type";
import {
  ADMIN_USER,
  digisetu_CLINIC_ID,
  USER_DATA,
  DOCTOR,
  NURSE,
  SUPERADMIN,
} from "../constants/const";
import { CLINIC_ADMIN_USER } from "../constants/const";
import { getFromLocalStorage } from "../Helpers/localStorageHelper";

import {
  getCommonMetadata,
  getHashCode,
  getPasswordHash,
  getIP,
  formatTime,
  platform,
  userAgent,
  browserName
} from "../utils/apiUtils";

const hashcode = getHashCode();
const commonMetadata = getCommonMetadata();

export const loginAction =
  ({
    loginType,
    userName,
    accessCountry,
    password,
    history,
    backupData,
    setDrSign,
  }) =>
    async (dispatch) => {
      let resp = await loginedApi.post("getcountrycode", {
        token: hashcode,
        version: "2.0",
        data: { browserTimeZone: commonMetadata.browserTimeZone },
        requestType: 1058,
      });
      const doctorscountrycode = resp.data.data;

      console.log(backupData);
      const res = await loginedApi.post("login", {
        token: hashcode,
        data: {
          ...commonMetadata,
          hashPassword: getPasswordHash(password),
          password: getPasswordHash(password),
          loginType: loginType,
          userName: userName?.toLowerCase(),
          browserTimeZone: commonMetadata.browserTimeZone,
          Ipaddress: doctorscountrycode.Ipaddress,
          currency: doctorscountrycode.currency,
          accessCountry: doctorscountrycode.Country,
        },
        requestType: 3,
      });

      if (res?.data?.data?.info) {
        return res.data.data;
      } else {
        dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

        console.log(res.data.data);

        await localStorage.setItem(
          "AccessToken",
          JSON.stringify(res.data.data.token)
        );
        const cookies = new Cookies();
        cookies.set("refreshtoken", JSON.stringify(res.data.data.refreshtoken));
        console.log(cookies.get("refreshtoken")); // Pacman
        await localStorage.setItem("userData", JSON.stringify(res.data.data));
        await localStorage.setItem("last_activity_timestamp", Date.now().toString());

        if (res.data?.data?.userType == "Patient") {
          if (backupData && backupData?.redirection) {
            history.push(backupData?.redirection);
          } else if (history?.location?.state?.redirection) {
            history.push(history?.location?.state?.redirection);
          } else {
            history.push("/dashboard");
          }
        } else if (
          res.data?.data?.userType == ADMIN_USER ||
          res.data?.data?.userType == CLINIC_ADMIN_USER ||
          res.data?.data?.userType == SUPERADMIN
        ) {
          history.push("/dashboard/mis/all");
        } else if (res.data?.data?.userType == DOCTOR) {
          history.push(`/projectlisting/${res.data.data?.profileId || ""}`);
          // history.push("/dashboard");
        } else if (res.data?.data?.userType == NURSE) {
          history.push("/dashboard");
        }

        // else if ( res.data?.data?.userType == CLINIC_ADMIN_USER) {
        //   history.push("/admindashboard");
        // }
        else {
          // history.push("/dashboard");
          // setDrSign(true)

          history.push("/dashboard");
        }
      }
      return res.data.data;
    };

export const checkUser =
  ({ type, searchkey }) =>
    async (dispatch) => {
      const response = await loginedApi.post("useravailability", {
        requestType: 22,
        token: hashcode,
        data: { searchtype: type, searchKey: searchkey },
      });

      if (response.status === 200) {
        return response.data && response.data;
      }
    };

export const logoutAction = (user, history, reason = "") => async (dispatch) => {
  console.info("DEBUG: Entering logoutAction. Reason:", reason);
  let userDataStr = await getFromLocalStorage(USER_DATA);
  let userData = null;
  try {
    userData = userDataStr ? JSON.parse(userDataStr) : null;
  } catch (e) {
    console.error("Failed to parse userData during logout:", e);
  }

  // Show timeout message if reason is timeout
  if (reason === "timeout") {
    toast.info("Your session has expired. Please log in again.", {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  // Always clear local state and redirect immediately
  console.info("DEBUG: logoutAction - Dispatching LOG_OUT_ACTION, CLEAR_INTERBRANCH_ADMIN, clearing localStorage, replacing history.");
  dispatch({ type: LOG_OUT_ACTION });
  dispatch({ type: CLEAR_INTERBRANCH_ADMIN });
  localStorage.clear();
  history.replace("/signin");

  if (userData && userData.userId) {
    console.info("DEBUG: logoutAction - Calling logout API for userId:", userData.userId);
    try {
      const response = await loginedApi.post("logout", {
        requestType: 4,
        token: hashcode,
        data: { userId: userData.userId },
      });
      console.log("Logout API response:", response);
    } catch (error) {
      console.error("Logout API failed, but continuing local logout:", error);
    }
  } else {
    console.log("No userData found in storage, skipping API logout call.");
  }
  return true;
};

export const loginwithotp =
  ({ loginType, userName, accessCountry, history, appoinment_form }) =>
    async (dispatch) => {
      const res = await loginedApi.post("login", {
        token: hashcode,
        data: {
          ...commonMetadata,
          Ipaddress: getIP(),
          hashPassword: "",
          password: "",
          accessCountry: accessCountry,
          loginType: loginType,
          userName: userName,
          isotpverified: true,
        },
        requestType: 3,
      });

      console.log(res);

      if (res.data.data.info) {
        toast.error("Invalid username or password !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        dispatch({
          type: LOGIN_SUCCESS_ACTION,
          payload: res.data.data,
        });

        await localStorage.setItem("userData", JSON.stringify(res.data.data));
        await localStorage.setItem("last_activity_timestamp", Date.now().toString());
        await localStorage.setItem(
          "AccessToken",
          JSON.stringify(res.data.data.token)
        );
        const cookies = new Cookies();
        cookies.set("refreshtoken", JSON.stringify(res.data.data.refreshtoken));

        console.log(res.data?.data?.userType);
        if (res.data?.data?.userType == "Patient") {
          if (appoinment_form?.routing) {
            let doctrId = localStorage.getItem("doctrID");

            history.push(`/BookAppointment/${doctrId}`);
          } else {
            history.push("/dashboard");
          }
        } else if (
          res.data?.data?.userType == ADMIN_USER ||
          res.data?.data?.userType == CLINIC_ADMIN_USER
        ) {
          history.push("/dashboard");
        } else if (
          res.data?.data?.userType == DOCTOR ||
          res.data?.data?.userType == NURSE
        ) {
          history.push("/dashboard");
        } else {
        }
      }
    };

export const loginWithGoogle =
  ({ Data, history, appoinment_form }) =>
    async (dispatch) => {
      const res = await loginedApi.post("login", {
        token: hashcode,
        data: {
          ...commonMetadata,
          Ipaddress: getIP(),
          hashPassword: "",
          password: "",
          accessCountry: "IN",
          loginType: "email",
          userName: Data?.email,
          isotpverified: true,
        },
        requestType: 3,
      });

      if (res.data.data.info) {
        return res.data.data;
      } else {
        dispatch({
          type: LOGIN_SUCCESS_ACTION,
          payload: res.data.data,
        });

        await localStorage.setItem("userData", JSON.stringify(res.data.data));
        await localStorage.setItem("last_activity_timestamp", Date.now().toString());
        console.log(res.data?.data?.userType);
        if (res.data?.data?.userType == "Patient") {
          if (appoinment_form?.routing) {
            let doctrId = localStorage.getItem("doctrID");

            history.push(`/BookAppointment/${doctrId}`);
          } else {
            history.push("/dashboard");
          }
        } else if (
          res.data?.data?.userType == ADMIN_USER ||
          res.data?.data?.userType == CLINIC_ADMIN_USER
        ) {
          history.push("/dashboard");
        } else {
          history.push("/dashboard");
        }
      }
      return res.data.data;
    };

export const updateLoginDetails = (data) => async (dispatch) => {
  dispatch({ type: UPDATE_LOGIN, payload: data });
};
export const validateresetPasswordKey = (key) => async (dispatch) => {
  const res = await loginedApi.post("getForgotPasswordUserDetails", {
    requestType: 12,
    token: hashcode,
    data: { key: key, isEncrypt: true },
  });

  console.log(res);

  if (res.data.data.info) {
    return { isSuccess: false, data: res.data.data.info };
  } else {
    return { isSuccess: true, data: res.data.data };
  }
  return res.data.data;
};
